module.exports = __webpack_public_path__ + "img/team2.25e46270.jpg";